import BreadCrumbs from "../../components/AdminC/Breadcrumb";
import { MdOutlineDashboard } from "react-icons/md";
import { LuBuilding2 } from "react-icons/lu";
import { BsEyeFill, BsFilter, BsPencilFill } from "react-icons/bs";
import { FaSearch, FaArrowRight, FaPlus } from "react-icons/fa";
import "../../App.css";
import { TbListDetails } from "react-icons/tb";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Tooltip } from "bootstrap";
import AdminCompanyFilter from "../../components/AdminC/AdminCompanyFilter";

const AdminCompany = () => {
  const adminToken = localStorage.getItem("adminToken");
  const [showFilterOption, setShowFilterOption] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companyCount, setCompanyCount] = useState(0);

  const [currentFilters, setCurrentFilters] = useState({});
  const handleFilterSearch = (filters) => {
    console.log("Filters received in Parent:", filters);
    setCurrentFilters(filters);
  };
  useEffect(() => {
    const getCompanies = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/adminCompany/getCompanies`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${adminToken}`,
            },
          }
        );
        setCompanies(response.data.data);
        setCompanyCount(response.data.pagination.total);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };
    getCompanies();
  }, [adminToken]);

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    [...tooltipTriggerList].map((el) => new Tooltip(el));
  }, []);

  const breadcrumbsData = [
    {
      text: "Dashboard",
      href: "/adminDashboard",
      icon: <MdOutlineDashboard />,
    },
    {
      text: "Company Detail",
      href: "/admindashboard/companies",
      icon: <LuBuilding2 />,
    },
  ];
  return (
    <div className=" px-3 px-sm-5 pt-2 pt-sm-3">
      <BreadCrumbs breadcrumbs={breadcrumbsData} />

      <div className="w-100 rounded-2 bg-white border company-container mt-4">
        <div
          className={`row d-flex flex-wrap justify-content-between align-items-center ${
            showFilterOption ? "" : "horizontal-line"
          }`}
        >
          <div className="col-12 col-md-3 mb-3">
            <h2 className="mb-0 company-details-heading">
              Company Detail Page
            </h2>
          </div>

          <div className="d-flex flex-wrap justify-content-end align-items-center filter-container gap-3 col-12 col-md-9">
            <div className="d-flex">
              <button
                className={`btn btn-light border me-3 company-filter ${
                  showFilterOption ? "filter-active" : ""
                }`}
                type="button"
                onClick={() => setShowFilterOption((prev) => !prev)}
              >
                <BsFilter className="me-2" size={20} />
                <span>Filters</span>
              </button>

              <Link
                to={"/adminDashboard/companies/add-new-company"}
                className="btn btn-dark add-company"
              >
                <FaPlus className="me-2" />
                <span>Add New Company</span>
              </Link>
            </div>
          </div>
        </div>

        {showFilterOption && (
          <AdminCompanyFilter onSearch={handleFilterSearch} />
        )}

        <div className="company-tabel">
          {/* Component Header */}
          <div className="d-flex align-items-center mb-4">
            <TbListDetails className="header-icon" size={22} />
            <h2 className="h4 mb-0 company-heading">{`Company List  -   [${companyCount} companies]`}</h2>
          </div>

          {/* Responsive Table Wrapper */}
          <div className="table-responsive">
            <table className="table table-hover align-middle table-bordered">
              {/* Table Head */}
              <thead className="table-light company-table-header">
                <tr>
                  <th scope="col" className="text-start sticky-col">
                    Company Name
                  </th>
                  <th scope="col" className="text-start">
                    Company URL
                  </th>
                  <th scope="col">Industry</th>
                  <th scope="col">Head Quarter</th>
                  <th scope="col">CEO</th>
                  <th scope="col">Company Size</th>
                  <th scope="col">Company Revenue</th>
                  <th scope="col">Created On</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              {/* Table Body */}
              <tbody className="company-tabel-body">
                {companies.map((company, index) => (
                  <tr key={index}>
                    <td className="sticky-col">
                      <div className="d-flex align-items-center">
                        <img
                          src={company.company_logo_url}
                          alt={`${company.company_name} logo`}
                          className="company-logo"
                        />
                        <span className="ms-3">{company.company_name}</span>
                      </div>
                    </td>
                    <td className="text-start">
                      <a
                        href={
                          company.company_url?.startsWith("https")
                            ? company.company_url
                            : `https://${company.company_url}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {company.company_url}
                      </a>
                    </td>
                    <td
                      className="industry-col"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title={company.industry || "-"}
                    >
                      {company.industry || "-"}
                    </td>
                    <td>{company.headquarter.split(",")[1].trim() || "-"}</td>
                    <td>{company.ceo || "-"}</td>
                    <td>{company.company_size || "-"}</td>
                    <td>{company.company_revenue || "-"}</td>
                    <td>{company.created_on || "-"}</td>
                    <td>
                      <span className="status-verified">
                        {company.company_status === 1 ? "Active" : "InActive"}
                      </span>
                    </td>
                    <td className="actions-icons">
                      <BsEyeFill className="me-3" />
                      <BsPencilFill />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdminCompany;
